var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Tooltip from '@material-ui/core/Tooltip';
import { createGlobalStyle } from 'styled-components';
var ClassStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiTooltip-tooltip {\n    margin: 8px 0;\n    padding: 4px 12px;\n    width: max-content;\n    max-width: 240px;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    color: #FFF;\n    border-radius: 8px;\n    background-color: #7F7F7F;\n  }\n"], ["\n  .MuiTooltip-tooltip {\n    margin: 8px 0;\n    padding: 4px 12px;\n    width: max-content;\n    max-width: 240px;\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: 400;\n    color: #FFF;\n    border-radius: 8px;\n    background-color: #7F7F7F;\n  }\n"])));
var SFTooltip = function (_a) {
    var title = _a.title, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, props = __rest(_a, ["title", "placement"]);
    return (_jsxs("div", { children: [_jsx(ClassStyle, {}), _jsx(Tooltip, __assign({ title: title || '' }, props, { placement: placement, enterTouchDelay: 0 }))] }));
};
export default SFTooltip;
var templateObject_1;
